import { SatelliteSystem } from 'api'
import { strings } from 'strings'

// export const

export enum Calendar {
  Persian,
  Gregorian,
}
export const CALENDAR_OPTIONS = [
  { label: strings.perisanCalendar, value: Calendar.Persian },
  { label: strings.gregorianCalendar, value: Calendar.Gregorian },
]

export enum BucketUnit {
  Minute = 'm',
  Hour = 'h',
}
export const BUCKET_OPTIONS = [
  { label: strings.minute, value: BucketUnit.Minute },
  { label: strings.hour, value: BucketUnit.Hour },
]
/**In milliseconds */
export const unitCoefficient = { [BucketUnit.Minute]: 60_000, [BucketUnit.Hour]: 3_600_000 }

export const SATELLITE_SYSTEM_OPTIONS = [
  { label: 'GPS', value: SatelliteSystem.GPS },
  { label: 'GLO', value: SatelliteSystem.GLO },
  { label: 'GAL', value: SatelliteSystem.GAL },
  { label: 'BDS', value: SatelliteSystem.BDS },
]

export const fullscreenIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M120-120v-200h80v120h120v80H120Zm520 0v-80h120v-120h80v200H640ZM120-640v-200h200v80H200v120h-80Zm640 0v-120H640v-80h200v200h-80Z"/></svg>'
export const fullscreenExitIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M240-120v-120H120v-80h200v200h-80Zm400 0v-200h200v80H720v120h-80ZM120-640v-80h120v-120h80v200H120Zm520 0v-200h80v120h120v80H640Z"/></svg>'
